import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function printRadCenterPli(input: { id: number; centerId: number; templates: string[] }) {
  const { id, centerId, templates } = input
  return restApiClient
    .url(constructApiUrl(API.rads.printRadCenterPli.url, { id, centerId }))
    .post({ templates })
}
